import * as React from 'react'
import SvgSprite from 'airship/patterns/svg-sprite'
import {DMColors} from 'airship/patterns/types'

interface Props {
  text: string
  color?: DMColors
  displayClasses?: string
}

const HelpIcon: React.FunctionComponent<Props> = ({
  text,
  color = 'grey-40',
  displayClasses = 'u-text-shrink-1'
}) => (
  <a rel="help" data-help={text}>
    <SvgSprite name="help-fill" color={color} displayClasses={displayClasses} />
  </a>
)

export default HelpIcon
